import { Component, OnInit, ContentChildren, QueryList, Input,
  Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { WizardItemDirective } from '../wizard/wizard-item.directive';
import { DomUtils } from '../../helpers/dom-utils';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  public ActiveIndex = 0;

  private _visible: boolean;

  public Loading = false;

  @ContentChildren(WizardItemDirective) items: QueryList<WizardItemDirective>;

  // tslint:disable-next-line:no-input-rename
  @Input() public height: number = 600;
  @Input('Header') public Header: string;
  @Input('EndLabel') public EndLabel: string;
  @Input('Cancel') public CanCancel: boolean = true;
  @Input('GoBack') public CanGoBack: boolean = true;

  @Input() public validateStep: EventEmitter<number>;
  @Input() public nextStep: EventEmitter<boolean>;

  @Output() visibleChange = new EventEmitter();
  @Input()
  get visible() {
    return this._visible;
  }
  set visible(val) {
    this._visible = val;
    this.ActiveIndex = 0;
    this.visibleChange.emit(this._visible);
  }

  @Output() onHidden = new EventEmitter();
  @Output() onShowing = new EventEmitter();
  @Output() end = new EventEmitter();

  @ViewChild('form', { static: false }) _form: ElementRef;

  constructor() { }

  ngOnInit() {
    if (this.nextStep) {
      this.nextStep.subscribe(change => {
        if (this.items.length === 1) {
          if (change === true) {
            this.ActiveIndex = 0;
            this.end.next();
            this.visible = false;
          } else {

          }
        } else {
          if (change === true) {
            this.ActiveIndex++;
            // focus first input
            window.setTimeout(() => {
              const formChildren = [].slice.call(this._form.nativeElement.children);
              formChildren.every(child => {
                const input = DomUtils.GetInputElement(child);
                if (input) {
                  input.focus();
                  return false; // break!
                }
                return true; // continue!
              });
            });
          }
          if (change != null) {
            this.Loading = false;
          }
        }
      });
    }
  }

  public OnShowing() {
    this.onShowing.next();
  }

  public NextItem() {
    if (this.items.length === this.ActiveIndex + 1) {
      this.FinishUp();
    } else {
      this.Loading = true;
      this.validateStep.next(this.ActiveIndex);
      return false;
    }
  }

  public PreviousItem() {
    this.ActiveIndex--;
  }

  public FinishUp() {
    this.ActiveIndex = 0;
    this.end.next();
    this.visible = false;
  }

  public Close() {
    this.onHidden.next();
    this.visible = false;
  }

  public FinalStepOnePage() {
    if (this.items.length === 1) {
      this.validateStep.next(this.ActiveIndex);
    }
  }

}
